// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#6F7881"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.6693 1.89258V5.3347C11.6693 5.80141 11.6693 6.03476 11.7601 6.21302C11.84 6.36982 11.9675 6.49731 12.1243 6.5772C12.3025 6.66803 12.5359 6.66803 13.0026 6.66803H16.4447M6.66927 12.5013V15.0013M13.3359 10.8346V15.0013M10.0026 8.7513V15.0013M16.6693 8.32482V14.3346C16.6693 15.7348 16.6693 16.4348 16.3968 16.9696C16.1571 17.44 15.7747 17.8225 15.3042 18.0622C14.7695 18.3346 14.0694 18.3346 12.6693 18.3346H7.33594C5.93581 18.3346 5.23574 18.3346 4.70096 18.0622C4.23056 17.8225 3.8481 17.44 3.60842 16.9696C3.33594 16.4348 3.33594 15.7348 3.33594 14.3346V5.66797C3.33594 4.26784 3.33594 3.56777 3.60842 3.03299C3.8481 2.56259 4.23056 2.18014 4.70096 1.94045C5.23574 1.66797 5.93581 1.66797 7.33594 1.66797H10.0124C10.6239 1.66797 10.9296 1.66797 11.2173 1.73704C11.4724 1.79829 11.7163 1.8993 11.94 2.03637C12.1923 2.19097 12.4085 2.40716 12.8408 2.83954L15.4977 5.4964C15.9301 5.92877 16.1463 6.14496 16.3009 6.39726C16.4379 6.62094 16.539 6.8648 16.6002 7.11989C16.6693 7.40761 16.6693 7.71335 16.6693 8.32482Z"
    />
  </svg>
);
const IconStatistics = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconStatistics;
